// extracted by mini-css-extract-plugin
export default {"root":"styles_root__FRpAU","isActive":"styles_isActive__G6tVe"};